export function isPrinterSettingsConfigured(printerSettings) {
  if (!printerSettings || typeof printerSettings !== "object") return false;
  const url = printerSettings.printerUrlAddress || printerSettings.printerUrl;
  return Boolean(url && String(url).trim());
}

export function isBusinessSettingsConfigured(receiptMetadata) {
  if (!receiptMetadata || typeof receiptMetadata !== "object") return false;
  return Boolean(receiptMetadata.businessName && String(receiptMetadata.businessName).trim());
}

export function isHomSetupComplete(printerSettings, receiptMetadata) {
  return (
    isPrinterSettingsConfigured(printerSettings) &&
    isBusinessSettingsConfigured(receiptMetadata)
  );
}

export function getHomSetupStep(printerSettings, receiptMetadata) {
  if (!isPrinterSettingsConfigured(printerSettings)) return 0;
  if (!isBusinessSettingsConfigured(receiptMetadata)) return 1;
  return -1;
}
